(() => {
  if (window.__fulfillmentInit) return;
  window.__fulfillmentInit = true;

  function getVariants(sectionId) {
    const el = document.getElementById(`product-variants-${sectionId}`);
    try { return JSON.parse(el?.textContent || '[]'); } catch { return []; }
  }

  function update(container, { resetBase = false } = {}) {
    if (container.dataset.tracked !== 'true') return;
    const sectionId = container.dataset.sectionId;
    const variants = getVariants(sectionId);
    const form = document.getElementById(`product-form-${sectionId}`) || container.closest('product-info')?.querySelector('form[is="product-form"]');
    const variant = variants.find(v => v.id === parseInt(form?.querySelector('[name="id"]')?.value, 10));
    if (!variant) return;

    const ready = container.querySelector('.product__inventory-fulfillment-ready');
    const mto = container.querySelector('.product__inventory-fulfillment-mto');
    if (!ready || !mto) return;

    if (resetBase || typeof container.dataset.baseShowMto === 'undefined') {
      container.dataset.baseShowMto = mto.classList.contains('hidden') ? 'false' : 'true';
    }
    const baseShowMto = container.dataset.baseShowMto === 'true';

    const qtyInput = document.getElementById(`Quantity-${sectionId}`);
    const invTracked = variant.inventory_management === 'shopify';
    const inv = variant.inventory_quantity ?? 0;
    const canContinue = variant.inventory_policy === 'continue';
    const minQty = Math.max(1, Number(qtyInput?.min) || Number(qtyInput?.dataset?.min) || 1);
    const rawQty = parseInt(qtyInput?.value, 10);
    const lineQty = Number.isFinite(rawQty) && rawQty > 0 ? rawQty : minQty;
    const effectiveQty = Math.max(lineQty, minQty);

    // Respect Liquid-rendered baseline and only force MTO for qty overflow on tracked continue-selling variants.
    const exceedsTrackedStock = invTracked && canContinue && inv > 0 && effectiveQty > inv;
    const showMto = baseShowMto || exceedsTrackedStock;

    ready.classList.toggle('hidden', showMto);
    mto.classList.toggle('hidden', !showMto);
  }

  function onQtyChange(e) {
    if (!e.target?.id?.startsWith('Quantity-')) return;
    const sectionId = e.target.id.replace('Quantity-', '');
    document.querySelectorAll(`[data-fulfillment-inventory][data-section-id="${sectionId}"]`).forEach(container => update(container));
  }

  function onVariantChange() {
    requestAnimationFrame(() => {
      document.querySelectorAll('[data-fulfillment-inventory][data-tracked="true"]').forEach(
        container => update(container, { resetBase: true })
      );
    });
  }

  function init() {
    document.querySelectorAll('[data-fulfillment-inventory][data-tracked="true"]').forEach(
      container => update(container, { resetBase: true })
    );
    document.addEventListener('input', onQtyChange);
    document.addEventListener('change', onQtyChange);
    document.addEventListener('variant:changed', onVariantChange);
    if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub?.subscribe) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
